/*******************************************************************
* PAGE        : TitleComponent
* REMARKS     : Comman Title Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 24-02-2026
********************************************************************/

const TitleComponent = ({ Title }) => {

    return (
        <div className="page-title-main">
            <h2>{Title}</h2>
        </div>
    )
}

export default TitleComponent;